/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';

import NdsThemeProviderPurple from '@ntuctech/devex-tangram/Theme/NdsThemeProviderPurple';

import ErrorPageContent from '../theme/ErrorPageContent';
import { datadogRum } from '@datadog/browser-rum-slim';

import { getPageQueryParams } from '../../utils';
import {
  ERROR_TITLE_DEFAULT,
  ERROR_BODY_DEFAULT,
  ERROR_FROM_AUTH0,
  ERROR_INVALID_REQUEST,
} from '../../constants';

const ErrorComp = ({ errorDescription }) => {
  const defaultErrorDesc = errorDescription ?? ERROR_INVALID_REQUEST;

  const [errorStr, setErrorStr] = React.useState('');

  React.useEffect(() => {
    const queryParams = getPageQueryParams();
    const { error_description: errorDesc = defaultErrorDesc } = queryParams;

    const finalErrorDesc = errorDesc === ERROR_FROM_AUTH0 ? ERROR_BODY_DEFAULT : errorDesc;

    setErrorStr(finalErrorDesc);
    const derivedError = new Error(finalErrorDesc);
    datadogRum.addError(derivedError);
  }, [defaultErrorDesc]);

  return (
    <NdsThemeProviderPurple>
      <ErrorPageContent title={ERROR_TITLE_DEFAULT} body={errorStr} />
    </NdsThemeProviderPurple>
  );
};

export default ErrorComp;

ErrorComp.propTypes = {
  errorDescription: PropTypes.string,
};

ErrorComp.defaultProps = {
  errorDescription: undefined,
};
